import React,{useState} from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../../hooks/usesAuth";
import AuthAPI from "../../../Services/auth/authAPI";
import CashierSidebar from "../sidebars/CashierSidebar";
import Cashier_header from "../headers/Cashier_header";

export const CashierLayout = ({ allowedRoles }) => {

    AuthAPI.setup();

    const { auth } = useAuth();
    const location = useLocation();


    return (AuthAPI.getUserRoles() ===
        allowedRoles[0]
    ) ? (
        <>
            {/* eslint-disable-next-line react/jsx-pascal-case */}
            <Cashier_header />
            <CashierSidebar />
            <main id="main" className="main">
                <Outlet />
            </main>

        </>
    ) : (
        <Navigate to="/login" state={{ from: location }} replace />
    );
};

export default CashierLayout;
